import FilterDropdown from './filtersDropdown';
import SortingDropdown from './sortingDropdown';

export default class Filters {
	constructor(urlFiltersCount) {
		this.dataGroup = 'filter-group';
		this.dataId = 'filter-id';
		this.dataDefault = 'filter-default';
		this.filterGroups = [];
		this.filterDropdown = new FilterDropdown();
		this.sortingDropdown = new SortingDropdown();
		this.timeout = null;
		this.initializeLocation();
		this.initializeCategoryButtons();

		document
			.querySelectorAll('[data-' + this.dataGroup + ']')
			.forEach(e => {
				e.addEventListener('click', el => this.filterClicked(el));

				const fn = e.getAttribute('data-' + this.dataGroup);
				if (this.filterGroups.indexOf(fn) === -1) {
					this.filterGroups.push(fn);
				}
			});

		this.initializeFromURL();
	}

	initializeFromURL() {
		if (window.location.hash.length > 1) {
			let data = new URLSearchParams(
				decodeURI(window.location.hash.slice(1)),
			);
			data.forEach((value, group) => {
				this.markActive(group.slice(0, group.indexOf('[')), value);
			});
		}

		this.updateCategoryButtons();
	}

	updateURLWithFilters() {
		const params = new URLSearchParams();

		document
			.querySelectorAll('[data-' + this.dataGroup + '].active')
			.forEach(e => {
				const name = e.getAttribute('data-' + this.dataGroup);
				const id = e.getAttribute('data-' + this.dataId);

				if (e.getAttribute('data-' + this.dataDefault) === 'true') {
					return;
				}

				if (name === 'sort') {
					params.set(name, id);
				} else {
					const existing = params.get(name)
						? params.get(name).split(',')
						: [];
					existing.push(id);
					params.set(name, existing.join(','));
				}
			});

		this.updateCategoryButtons();

		window.location.hash = params.toString();
	}

	dataForQuery() {
		const data = {};
		let shouldFetchLocation = false;

		document
			.querySelectorAll('[data-' + this.dataGroup + '].active')
			.forEach(e => {
				const name = e.getAttribute('data-' + this.dataGroup);
				const id = e.getAttribute('data-' + this.dataId);
				const isDefault =
					e.getAttribute('data-' + this.dataDefault) === 'true';

				if (isDefault) {
					return;
				}

				if (!Object.prototype.hasOwnProperty.call(data, name)) {
					data[name] = [];
				}
				if (name === 'sort') {
					data[name] = id;
					if (id === 'location') {
						shouldFetchLocation = true;
					}
				} else {
					data[name].push(id);
				}
			});

		data.filters = this.getFiltersCount();

		if (shouldFetchLocation) {
			return this.getLocation().then(location => {
				data.latitude = location[0];
				data.longitude = location[1];
				return data;
			});
		} else {
			return Promise.resolve(data);
		}
	}

	filterClicked(el) {
		const clickedElement = el.currentTarget;
		let parentDropdown = null;

		parentDropdown = clickedElement.closest('.filter-dropdown-content');
		if (!parentDropdown) {
			parentDropdown = clickedElement.closest(
				'.items-filter-dropdown-content',
			);
		}
		if (!parentDropdown) {
			parentDropdown = clickedElement.closest('.categories');
		}
		if (
			parentDropdown &&
			parentDropdown.hasAttribute('data-single-select')
		) {
			if (clickedElement.classList.contains('active')) {
				clickedElement.classList.remove('active');
			} else {
				parentDropdown
					.querySelectorAll('[data-' + this.dataGroup + '].active')
					.forEach(e => {
						e.classList.remove('active');
					});

				clickedElement.classList.add('active');
			}

			const event = new CustomEvent('filter:changed', {
				detail: {
					group: clickedElement.getAttribute(
						'data-' + this.dataGroup,
					),
				},
			});

			window.dispatchEvent(event);
			//this.filterDropdown.closeAllDropdowns();
			this.updateURLWithFilters();
		} else {
			// Pokud není single select
			clickedElement.classList.toggle('active');

			if (this.timeout) {
				clearTimeout(this.timeout);
			}

			this.timeout = setTimeout(() => {
				window.dispatchEvent(new Event('filter:changed'));
				//this.filterDropdown.closeAllDropdowns();
				this.updateURLWithFilters();
			}, 1000);
		}
	}

	fromServerResponse(obj) {
		document
			.querySelectorAll('[data-' + this.dataGroup + ']')
			.forEach(el => el.classList.remove('active'));
		for (let group in obj) {
			if (group === 'sort') {
				this.markActiveSort(group, obj);
			} else {
				if (group === 'latitude' || group === 'longitude') {
					continue;
				}
				obj[group].forEach(id => {
					this.markActive(group, id);
				});
			}
		}
	}

	markActiveSort(group, obj) {
		if (obj[group] === null) {
			let activeSort = document.querySelectorAll(
				'[data-' + group + '].active',
			);
			if (activeSort.length === 0) {
				let defaultSort = document.querySelector(
					`[data-${this.dataGroup}="${group}"][data-${this.dataDefault}="true"]`,
				);
				if (defaultSort) {
					defaultSort.classList.add('active');
				}
			}
		} else {
			this.markActive(group, obj[group]);
		}
	}

	markActive(group, id) {
		const elements = document.querySelectorAll(
			`[data-${this.dataGroup}="${group}"][data-${this.dataId}="${id}"]`,
		);

		elements.forEach(element => {
			element.classList.add('active');
		});
	}

	markInactive(group, id) {
		const elements = document.querySelectorAll(
			`[data-${this.dataGroup}="${group}"][data-${this.dataId}="${id}"]`,
		);

		elements.forEach(element => {
			element.classList.remove('active');
		});
	}

	getLocation() {
		document.body.classList.add('is-loading');

		return new Promise((resolve, reject) => {
			const storedLatitude = parseFloat(localStorage.getItem('latitude'));
			const storedLongitude = parseFloat(
				localStorage.getItem('longitude'),
			);
			const storedTimestamp = localStorage.getItem('locationTimestamp');

			const EXPIRY_DURATION = 60 * 60 * 1000; // 5 minut

			// Pokud máme uloženou polohu a ještě nevypršela
			if (
				storedLatitude &&
				storedLongitude &&
				storedTimestamp &&
				Date.now() - storedTimestamp < EXPIRY_DURATION
			) {
				console.log('Using stored location');
				resolve([storedLatitude, storedLongitude]);
				return;
			}

			if (!navigator.geolocation) {
				alert('Geolokace není podporována vaším prohlížečem');
				reject('Geolocation not supported');
				return;
			}

			navigator.geolocation.getCurrentPosition(
				position => {
					const { latitude, longitude } = position.coords;
					localStorage.setItem('latitude', latitude.toString());
					localStorage.setItem('longitude', longitude.toString());
					localStorage.setItem(
						'locationTimestamp',
						Date.now().toString(),
					);
					resolve([latitude, longitude]);
				},
				error => {
					switch (error.code) {
					case error.PERMISSION_DENIED:
						this.updateLocationFilterText(
							'vzdálenosti (zamítnuto)',
						);
						console.log(
							'Uživatel zamítl požadavek na Geolokaci.',
						);
						break;
					case error.POSITION_UNAVAILABLE:
						this.updateLocationFilterText(
							'vzdálenosti (nedostupné)',
						);
						alert('Informace o poloze nejsou k dispozici.');
						break;
					case error.TIMEOUT:
						this.updateLocationFilterText(
							'vzdálenosti (vypršel čas)',
						);
						alert(
							'Požadavek na získání polohy uživatele vypršel.',
						);
						break;
					default:
						this.updateLocationFilterText(
							'vzdálenosti (chyba)',
						);
						alert('Došlo k neznámé chybě při získání polohy.');
					}
					reject(error);
				},
				{
					enableHighAccuracy: true,
					timeout: 5000,
					maximumAge: 5 * 60 * 1000, // 5 minutes
				},
			);
			document.body.classList.remove('is-loading');
		});
	}

	initializeLocation() {
		if (!navigator.geolocation) {
			this.disableLocationFilter();
			return;
		}
	}

	updateLocationFilterText(text) {
		const locationFilterButton = document.querySelector(
			'[data-filter-id="location"]',
		);
		if (locationFilterButton) {
			locationFilterButton.textContent = text;
		}
	}

	disableLocationFilter() {
		const locationFilterButton = document.querySelector(
			'[data-filter-id="location"]',
		);
		if (locationFilterButton) {
			locationFilterButton.setAttribute('disabled', 'true');
			locationFilterButton.textContent = 'vzdálenosti (nepodporováno)';
		}
	}

	initializeCategoryButtons() {
		this.catButtons = document.querySelectorAll('.category');

		this.catButtons.forEach(e => {
			e.addEventListener('click', () => this.categoryButtonClicked(e));
		});
	}

	categoryButtonClicked(el) {
		const group = 'cat';
		const id = el.getAttribute('data-cat-id');

		const elements = document.querySelectorAll(
			`[data-${this.dataGroup}="${group}"]`,
		);
		elements.forEach(element => {
			element.classList.remove('active');
		});

		if (el.classList.contains('active')) {
			el.classList.remove('active');
		} else {
			this.catButtons.forEach(e => {
				e.classList.remove('active');
			});
			el.classList.add('active');
			this.markActive(group, id);
		}

		window.dispatchEvent(new Event('filter:changed'));
	}

	updateCategoryButtons() {
		const group = 'cat';

		this.catButtons.forEach(e => {
			e.classList.remove('active');
		});

		const elements = document.querySelectorAll(
			`[data-${this.dataGroup}="${group}"].active`,
		);
		if (elements.length === 1) {
			const catId = elements[0].getAttribute(`data-${this.dataId}`);
			const categoryButton = document.querySelector(
				`.category[data-cat-id="${catId}"]`,
			);
			if (categoryButton) {
				categoryButton.classList.add('active');
			}
		}
	}

	getFiltersCount() {
		let data = [];
		document
			.querySelectorAll('[data-' + this.dataGroup + ']')
			.forEach(e => {
				const name = e.getAttribute('data-' + this.dataGroup);
				const id = e.getAttribute('data-' + this.dataId);

				if (name !== 'sort') {
					data.push({ name, id });
				}
			});

		return data;
	}

	setFiltersCount(filters) {
		filters.forEach(filter => {
			const elements = document.querySelectorAll(
				`[data-${this.dataGroup}="${filter.name}"][data-${this.dataId}="${filter.id}"]`,
			);
			elements.forEach(element => {
				if (filter.count === 0) {
					element.classList.add('disabled');
				} else {
					element.classList.remove('disabled');
				}

				const countElement = element.querySelector(
					'.items-filter-count',
				);
				if (countElement) {
					countElement.textContent = filter.count;
				}
			});
		});
	}
}
